/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductCategoryDto } from '../../models/product-category-dto';
import { ProductCategoryUpdateOrderDto } from '../../models/product-category-update-order-dto';

export interface ProductCategoryControllerUpdateOrder$Params {
      body: Array<ProductCategoryUpdateOrderDto>
}

export function productCategoryControllerUpdateOrder(http: HttpClient, rootUrl: string, params: ProductCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, productCategoryControllerUpdateOrder.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductCategoryDto>>;
    })
  );
}

productCategoryControllerUpdateOrder.PATH = '/api/product-category/order';
